import React from 'react';
import { connect } from 'react-redux';
import Container from 'xgimi-ui/Container';
import Accordion from './Accordion';

import StoreComponent, { mapStateToProps } from '../../appComponents/Store';

import s from './.module.scss';

interface Props {

}

/**
 * iPad版本号
 */
class Component extends StoreComponent<Props> {
  render(): React.ReactNode {
    return (
      <Container className={s.container} isMobile={true}>
        <Accordion title="v1.0" date="2021-09-29" isDefaultExpand={true}>
          <div>1.设备管理：iPad可以搜索、连接、操控、删除设备</div>
          <div>2.内容包管理：支持查询/更新iPad和所操控的设备的内容包</div>
          <div>3.内容检索：支持搜索、切换菜单来检索内容</div>
          <div>4.内容播放：无操控设备时，支持在iPad内置播放内容。有操控设备且设备已下载内容时，支持在设备投屏播放该内容</div>
        </Accordion>
      </Container>
    );
  }
}

export default connect(mapStateToProps)(Component);
